var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import Icon from '../../icon';
import { FA_DONATE, FA_ENVELOPE } from '../../../const/icon-props';
import { CBRHeader, CBRHeaderWrapper, CBROptionsWrapper, CardContainer } from './subcomponents';
import RequestRefundButton from '../../request-refund-button';
import StartChat from '../../start-chat';
import Eligible from './eligible';
import StepButton from '../../step-button';
import RefundError from '../error';
import Submitted from './submitted';
import RequestRefundOnly from '../request-refund-only';
import CBRContext from '../context';
import { analyticsValues, backToAccountManagerDataProps, backToAccountManagerSubmittedDataProps, triggerAnalyticsKeys } from '../../../const/analytics';
import { CardFooter } from '../execution/subcomponents';
var Eligibility = function (_a) {
    var _b;
    var currentBalance = _a.currentBalance, isBusinessError = _a.isBusinessError, isAccessDenied = _a.isAccessDenied, isOtherBusinessError = _a.isOtherBusinessError, isRefundEligible = _a.isRefundEligible, isSetPay = _a.isSetPay, isSubmitted = _a.isSubmitted, submittedSubText = _a.submittedSubText, startExecution = _a.startExecution;
    var t = useTranslation().t;
    var _c = useContext(CBRContext), backToAccountManagerHandler = _c.backToAccountManagerHandler, triggerAnalyticsEvent = _c.triggerAnalyticsEvent;
    var headerText = t('header.applyCurrentBalance', {
        currentBalance: "-$".concat(currentBalance.slice(1)),
        optionText: t('header.theseOptionsText')
    });
    var requestRefundHeader = t('header.requestRefundCheck');
    if (isOtherBusinessError) {
        triggerAnalyticsEvent((_b = {},
            _b[triggerAnalyticsKeys.pageKind] = analyticsValues.cbr,
            _b[triggerAnalyticsKeys.pageFunction] = analyticsValues.manageCreditBalance,
            _b[triggerAnalyticsKeys.pageName] = analyticsValues.submitted,
            _b[triggerAnalyticsKeys.message] = 'refund request in progress',
            _b));
        return _jsx(RefundError, {});
    }
    if (isSetPay) {
        return (_jsx(RequestRefundOnly, { isBusinessError: isBusinessError, currentBalance: currentBalance, isSetPay: isSetPay, eligibilityHeader: requestRefundHeader, startExecution: startExecution, icon: FA_ENVELOPE }));
    }
    if (isSubmitted) {
        return (_jsxs(_Fragment, { children: [_jsx(Submitted, { desc: t('text.requestInProgress'), subtext: submittedSubText }), _jsx(CardFooter, { children: _jsx(StepButton, __assign({ onClick: backToAccountManagerHandler, primary: true }, backToAccountManagerSubmittedDataProps, { textContent: t('button.backToAccountManager') })) })] }));
    }
    return (_jsxs(CardContainer, { children: [_jsx(CBRHeaderWrapper, { children: _jsx(CBRHeader, { children: headerText }) }), _jsxs(CBROptionsWrapper, { children: [_jsx(Eligible, { icon: _jsx(Icon, { icon: FA_DONATE, title: "eligible", size: "lg" }), header: t('header.applyNextPurchase'), currentBalance: currentBalance, subtext: t('subtext.applyCurrentBalanceAutomatically'), button: _jsx(StepButton, __assign({ onClick: backToAccountManagerHandler, primary: true }, backToAccountManagerDataProps, { textContent: t('button.backToAccountManager') })) }), isRefundEligible && !isAccessDenied && (_jsx(Eligible, { icon: _jsx(Icon, { icon: FA_ENVELOPE, title: "eligible", size: "lg" }), header: requestRefundHeader, currentBalance: currentBalance, subtext: t('subtext.receiveRefundCheck'), button: _jsx(RequestRefundButton, { onClickHandler: startExecution }) })), (isBusinessError || isAccessDenied) && (_jsx(Eligible, { icon: _jsx(Icon, { icon: faEnvelope, title: "not-eligible" }), header: requestRefundHeader, currentBalance: currentBalance, subtext: _jsx(StartChat, {}) }))] })] }));
};
export default Eligibility;
